<template>
  <b-overlay
    :show="showLoader"
    rounded="sm"
  >
    <b-card>
      <!-- Título de documentación obligatoria -->
      <b-card-title class="mb-1">
        Configuración de recurso
      </b-card-title>

      <validation-observer ref="formRecurso">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="nombre"
            rules="required|regex:^([a-zA-Z0-9\u00f1\u00d1À-ÿ ]+)$"
          >
            <b-form-input
              v-model="recurso.nombre"
              :state="errors.length > 0 ? false:null"
              placeholder="Nombre de recurso"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </validation-observer>

      <b-row class="mt-2">
        <!-- Cancelar -->
        <b-col
          v-if="willUpdate"
          md="6"
        >
          <b-button
            variant="danger"
            block
            @click="$emit('cancelUpdate'); recurso = {}, willUpdate = false"
          >
            Cancelar edición
          </b-button>
        </b-col>

        <!-- Guardar -->
        <b-col :md="(willUpdate) ? '6' : '12' ">
          <b-button
            variant="primary"
            block
            @click.prevent="validationForm"
          >
            Guardar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import { isObject, isEmptyObject, formhttp } from '@core/utils/utils'
import { required } from '@validations'
import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { saveChanges } from './useRecursos'

export default {
  components: {
    BCard,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    selected: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const formRecurso = ref(null)
    const willUpdate = ref(false)
    const showLoader = ref(false)
    const recurso = ref({ nombre: '' })
    const getValuesToSend = computed(() => {
      const dataReturn = { n: recurso.value.nombre }

      if (recurso.value.id !== undefined && recurso.value.id) {
        dataReturn.action = 3
        dataReturn.x = recurso.value.id
      } else {
        dataReturn.action = 2
      }

      return dataReturn
    })

    //* Save changes
    const save = () => {
      showLoader.value = true
      saveChanges(getValuesToSend.value)
        .then(response => {
          const { icon, label } = formhttp(response.status)
          showLoader.value = false

          if (response.status === 200) {
            recurso.value = { nombre: '' }
            emit('updateData')
            emit('cancelUpdate')
            recurso.value = { nombre: '' }
            willUpdate.value = false
          }

          toast({
            component: ToastificationContent,
            props: {
              title: 'Resultado de petición',
              text: response.message,
              icon,
              variant: label,
            },
          },
          { timeout: 8000 })
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en guardando cambios',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    //* Form validate
    const validationForm = () => {
      formRecurso.value.validate().then(success => {
        if (success) save()
      })
    }

    //* Watch if selected is empty
    watch(() => props.selected, value => {
      if (value && isObject(value) && !isEmptyObject(value)) {
        const { id, nombre } = value
        recurso.value.id = id
        recurso.value.nombre = nombre
        willUpdate.value = true
      } else recurso.value = { nombre: '' }
    })

    return {
      recurso,
      // Methods
      validationForm,
      // Filters
      required,
      // Flag
      willUpdate,
      // Loader
      showLoader,
      // Extra
      formRecurso,
    }
  },
}
</script>
